import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import DashboardComponent from "./DashboardComponent";
import { API_URL } from "./config";

function CustomerSelection() {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState("");

  useEffect(() => {
    fetchCustomers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(`${API_URL}/companysetup`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      setCustomers(data);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const handleCustomerSelect = (event) => {
    const customerId = event.target.value;
    setSelectedCustomerId(customerId);
    
    // Log the selected customer details
    const selectedCustomer = customers.find(customer => customer.company_setup_id === Number(customerId));
    if (selectedCustomer) {
      console.log('Selected Customer Details:', selectedCustomer);
    }
  };

  const handleViewStatement = () => {
    const selectedCustomer = customers.find(customer => customer.company_setup_id === Number(selectedCustomerId));
    if (selectedCustomer) {
      navigate('/AccountStatement', { state: { customer: selectedCustomer, selectedCustomer } });
    }
  };

  return (
    <DashboardComponent>
      <div className="container-fluid" style={{
        backgroundColor: "#f8f9fa",
        minHeight: "100vh",
        padding: "20px",
        marginTop: "30px",
        width: "100%",
      }}>
        <header className="my-3 text-center">
          <h1 className="my-3" style={{ color: "#333", fontSize: "1.8rem" }}>
            Select Customer To View Statement
          </h1>
        </header>

        <div className="form-group">
          <label htmlFor="customerSelect">Customers</label>
          <select 
            id="customerSelect" 
            className="form-control" 
            value={selectedCustomerId} 
            onChange={handleCustomerSelect}
          >
            <option value="">Select a customer</option>
            {customers.map(customer => (
              <option key={customer.company_setup_id} value={customer.company_setup_id}>
                {customer.name}
              </option>
            ))}
          </select>
        </div>

        <button 
          className="btn btn-primary mt-3" 
          onClick={handleViewStatement} 
          disabled={!selectedCustomerId}
        >
          View Statement
        </button>
      </div>
    </DashboardComponent>
  );
}

export default CustomerSelection;